import type { i18n as i18nType } from 'i18next';
import { use } from 'i18next';
import Backend from 'i18next-http-backend';
import Cookies from 'js-cookie';
import { initReactI18next } from 'react-i18next';

const getLanguage = () => {
  const urlLocale = new URLSearchParams(globalThis.location.search).get('lang');

  if (urlLocale) {
    return urlLocale;
  }

  return Cookies.get('i18next');
};

// Записываем возможный язык из куки в переменную
const languageFromCookie = getLanguage();

// Здесь убираем автодетекцию языка
const i18next: i18nType = use(Backend).use(initReactI18next);

const resources: Record<string, Record<string, any>> = {};

export const availableLanguages: {
  [key: string]: { order: number; value: string };
} = {
  ar: { order: 12, value: 'العربية' },
  de: { order: 3, value: 'Deutsche' },
  en: { order: 1, value: 'English' },
  es: { order: 2, value: 'Español' },
  fa: { order: 16, value: 'فارسی' },
  fr: { order: 4, value: 'Français' },
  ja: { order: 14, value: '日本語' },
  kk: { order: 10, value: 'Қазақша' },
  ko: { order: 13, value: '한국어' },
  pa: { order: 17, value: 'ਪੰਜਾਬੀ' },
  pl: { order: 11, value: 'Polski' },
  pt: { order: 15, value: 'Português' },
  ru: { order: 6, value: 'Русский' },
  tr: { order: 5, value: 'Türkçe' },
  uk: { order: 7, value: 'Українська' },
  uz: { order: 9, value: "O'zbekcha" },
  zh: { order: 8, value: '中文' },
};

const supportedLanguages = Object.keys(availableLanguages);

async function loadTranslations(language: string) {
  const defaultTranslations = await import(`./translation/${language}/default.json`);

  resources[language] = {
    default: defaultTranslations.default ?? defaultTranslations,
  };
}

await Promise.all(supportedLanguages.map(loadTranslations));

i18next.init({
  defaultNS: 'default',
  detection: {
    caches: ['localStorage', 'cookie'],
    order: ['cookie', 'navigator', 'localStorage'],
  },

  fallbackLng: Cookies.get('i18next'),

  interpolation: {
    escapeValue: false,
  },
  // В этой строчек добавляем переменную либо язык по умолчанию, он же "en"
  lng: languageFromCookie || 'en',
  ns: ['translation'],
  resources,
  supportedLngs: supportedLanguages,
});

export { default } from 'i18next';
